module.exports = __webpack_public_path__ + "img/team_2.8335b268.jpg";